import { breakpointAtLeast, throttle, videoLoad } from './utils.js';

(function ($) {
  // Load videos, only on devices larger than 'medium'
  $.each($('.js-blob-image-video'), function () {
    var $currentVideo = $(this);

    if ($currentVideo.length) {
      // Load video on resize
      $(window).on(
        'resize',
        throttle(function () {
          videoLoad($currentVideo);
        }, 10),
      );

      // Load video on page load
      videoLoad($currentVideo);
    }
  });

  // Autoplay video when scrolled to it
  let wpVideo = document.querySelectorAll('.js-blob-image-video--1');
  if (wpVideo.length === 0) {
    wpVideo = document.querySelectorAll('.js-blob-image-video');
  }

  if (wpVideo.length > 0) {
    // Autoplay when scrolled to it using intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (breakpointAtLeast('medium')) {
            entry.target.play();
          }
        }
      });
    });

    wpVideo.forEach((video) => {
      observer.observe(video);
    });
  }

  // Play video when switching pillar tab
  $('.bbc-wb-pillars__tabs-nav-btn').on('click', function () {
    const $video = $('.js-blob-image-video');
    const $currentVideo = $('.js-blob-image-video--' + $(this).data('index'));
    if ($currentVideo.length > 0 && breakpointAtLeast('medium')) {
      // Play current and pause others
      $video.get(0).pause();
      $currentVideo.get(0).play();
    }
  });
})(jQuery);
